import { Anchor, BaseModal, Button, Flex, Group, Image, Text, tinyButtons } from '@byecode/ui'
import { getAssetUrl } from '@lighthouse/assets'
import { getFileTypeByUrl, TitleInContentModal, useAtomAction, useAtomData, VideoPlayer } from '@lighthouse/shared'
import { find, findIndex } from 'rambda'
import React, { useCallback, useState } from 'react'
import styled from 'styled-components'

import { appGuideAtom } from '@/atoms/application/state'
import { updateUserAtom } from '@/atoms/auth/action'
import { useUser } from '@/hooks/useUser'
import * as srv from '@/services'

import { guideTaskList } from './constants'
import { StepList } from './StepList'
import { TaskList } from './TaskList'

interface IGuideTaskProps {
    onClose: () => void
}

const SCxContainer = styled.div`
    position: relative;
    width: 100%;
    /* max-height: 600px; */
    display: flex;
    flex-direction: column;
    /* overflow-y: auto; */
    /* ${tinyButtons} */
    background-image: url(${getAssetUrl('guide', 'task_background.png')});
`

const SCxModalFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 21px;
    button {
        width: 90px;
        height: 40px;
    }
`

export const GuideTask: React.FunctionComponent<IGuideTaskProps> = ({ onClose }) => {
    const [taskId, setTaskId] = useState('')
    const [stepIndex, setStepIndex] = useState(-1)
    const user = useUser()
    const { run: updateUser } = useAtomAction(updateUserAtom)

    const task = find(item => item.id === taskId, guideTaskList)

    const step = task?.steps?.[stepIndex]

    const preview = step?.source

    const previewFileType = getFileTypeByUrl(preview ?? '')

    const handleModalClose = useCallback(() => {
        setStepIndex(-1)
    }, [])

    const handleFinishedTask = useCallback(
        async (ids: string[]) => {
            setStepIndex(-1)
            const finishedTaskList = new Set([...(user.userCompletedTask ?? []), ...ids])
            const res = await srv.taskCompleted([...finishedTaskList])
            if (res) {
                updateUser({ userCompletedTask: [...finishedTaskList] })
            }
        },
        [updateUser, user.userCompletedTask]
    )

    return (
        <>
            <SCxContainer>
                {taskId ? (
                    <StepList
                        taskId={taskId}
                        stepId={step?.id}
                        onBack={() => setTaskId('')}
                        onChangeStep={setStepIndex}
                        onClose={onClose}
                    />
                ) : (
                    <TaskList
                        onChangTask={id => {
                            setTaskId(id)
                            setStepIndex(-1)
                        }}
                        onClose={onClose}
                    />
                )}
                {task && (
                    <TitleInContentModal
                        open={stepIndex !== -1}
                        width={738}
                        onClose={() => {
                            handleModalClose()
                        }}
                        styles={{
                            desktop: {
                                modal: { borderStyle: 'none', position: 'relative' },
                                header: {
                                    position: 'absolute!important',
                                    right: 0,
                                    top: 0,
                                    zIndex: 2,
                                    height: 'auto!important'
                                },
                                close: {
                                    color: 'var(--color-gray-500)',
                                    backgroundColor: 'rgba(255,255,255,0.5)!important'
                                }
                            }
                        }}
                    >
                        <div style={{ background: previewFileType === 'image' ? 'var(--color-white)' : 'var(--color-black)' }}>
                            {preview ? (
                                previewFileType === 'image' ? (
                                    <Image src={preview} />
                                ) : (
                                    <VideoPlayer source={preview} autoplay isController ratio="16:9" />
                                )
                            ) : null}
                        </div>
                        <div style={{ padding: 24 }}>
                            {/* <Text whiteSpace="pre-wrap" size={16} weight={600} lineHeight="24px">
                                {step?.title}
                            </Text> */}
                            <Text whiteSpace="pre-wrap" size={16} align="left" lineHeight="24px">
                                {step?.describe}
                            </Text>
                            <SCxModalFooter>
                                <Button
                                    type="tag"
                                    style={{ backgroundColor: 'var(--color-gray-100)', width: 'auto', height: 30 }}
                                    radius={100}
                                >
                                    {stepIndex + 1}/{task?.steps?.length ?? 1}
                                </Button>
                                <Flex gap={12}>
                                    {stepIndex > 0 && (
                                        <Button
                                            type="tag"
                                            style={{ backgroundColor: 'var(--color-gray-100)' }}
                                            onClick={() => {
                                                setStepIndex(v => v - 1)
                                            }}
                                        >
                                            上一步
                                        </Button>
                                    )}
                                    {stepIndex < (task?.steps?.length ?? 0) && stepIndex !== (task?.steps?.length ?? 0) - 1 && (
                                        <Button
                                            type="primary"
                                            onClick={() => {
                                                setStepIndex(v => v + 1)
                                            }}
                                        >
                                            下一步
                                        </Button>
                                    )}
                                    {stepIndex === (task?.steps?.length ?? 0) - 1 && (
                                        <Button
                                            type="primary"
                                            onClick={() => {
                                                handleFinishedTask(task.steps.map(v => v.id))
                                            }}
                                        >
                                            完成
                                        </Button>
                                    )}
                                </Flex>
                            </SCxModalFooter>
                        </div>
                    </TitleInContentModal>
                )}
            </SCxContainer>
        </>
    )
}
